/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { observer, inject } from 'mobx-react';
import OverviewTermInterestSavingsComponent from './OverviewTermInterestSavingsComponent';

@observer
class OverviewHeaderComponent extends React.Component {
  render() {
    const termInterestSavingsSeriesData = this.props.OverviewData.termInterestSavingsSeries[1].data;
    const showTermInterestSavingsComponent = _.some(termInterestSavingsSeriesData, (item => item > 0));

    return (
      <div className="overview-container__header">
        <div className="large-84 row columns">
          <h1>Hoeveel kunt u besparen?</h1>
          <h1>Bereken nu uw looptijdrente</h1>
        </div>
        <div className="row columns">
          <div className="large-60 medium-84 small-84 columns">
            <p className="overview-container__header-text">
              Hypotheekrentetarieven worden in de meeste gevallen vergeleken op basis van de aanvangsrente bij het
              afsluiten van de hypotheek en niet over de te betalen hypotheekrente gedurende de looptijd van de hypotheek.
              Bij vergelijken op de aanvangsrente wordt er vaak geen rekening gehouden met het vervallen van de zogenaamde
              renteopslagen gedurende de looptijd van de hypotheek.
            </p>
            <p className="overview-container__header-text">
              De looptijdrente geeft voor de consument een veel beter beeld van de totale kosten van een hypotheek
              gedurende de looptijd van een hypotheek.
            </p>
            <h2 className="overview-container__sub-header">Looptijdrente</h2>
            <p className="overview-container__header-text">
              De looptijdrente is de rente gedurende de gehele looptijd van de hypotheek waarbij de renteopslag
              automatisch vervalt als er voldoende is afgelost. Zodra de hypotheeklening door aflossen in een lagere
              risicoklasse valt, verlaagt de geldverstrekker de hypotheekrente. De aflossing kan maandelijks plaatsvinden,
              eventueel in combinatie met een extra bedrag. We nemen daarbij dus alleen die aanbieders en producten mee
              die dit pro actief en automatisch doen zonder dat de klant dat zelf in de gaten hoeft te houden of daarvoor
              zelf in actie hoeft te komen en / of extra kosten hoeft te betalen.
            </p>
            <h2 className="overview-container__sub-header">Hypotheekvorm bepaalt mede voordeel looptijdrente</h2>
            <p className="overview-container__header-text">
              Het verschil in de te betalen hypotheekrente komt vooral tot uiting bij een lineaire hypotheek en een
              annuïtaire hypotheek. Bij een aflossingsvrije hypotheek wordt er tijdens de looptijd immers niets afgelost
              en zal er geen sprake zijn van automatische risicoklasse daling. Dit zal meestal ook gelden bij hypotheken
              met Nationale Hypotheekgarantie (NHG) omdat deze hypotheken al in de laagste risicoklasse vallen (een
              enkele geldverstrekker hanteert ook risicoklassen bij hypotheken met NHG).
            </p>
          </div>

          <div className="no-tablet large-20 medium-84 columns">
            <OverviewTermInterestSavingsComponent
              termInterestSavingsSeries={this.props.OverviewData.termInterestSavingsSeries}
              show={showTermInterestSavingsComponent}
            />
          </div>
        </div>
      </div>
    );
  }
}

OverviewHeaderComponent.propTypes = {
  OverviewData: PropTypes.shape({
    termInterestSavingsSeries: PropTypes.arrayOf(PropTypes.shape({})),
  }),
};

OverviewHeaderComponent.defaultProps = {
  OverviewData: {
    termInterestSavingsSeries: []
  },
};

export default inject('OverviewData')(OverviewHeaderComponent);
